import { api } from '.';

import { ApiRoutes } from '@/constant/api';

import { PersonBookingResponseType, PersonByUsernameResponseType } from '@/types/person';

import { PersonsResponseType } from '@/shared/types/person.types';

const personsApi = api.injectEndpoints({
	endpoints: (builder) => ({
		getPersons: builder.query<PersonsResponseType, { limit?: number; offset?: number }>({
			query: ({ limit, offset }) => ({
				url: ApiRoutes.Persons,
			}),
			providesTags: ['Persons'],
		}),
		getPersonByUserId: builder.query<PersonByUsernameResponseType, number>({
			query: (id) => ({
				url: `${ApiRoutes.Persons}/${id}`,
			}),
		}),
		getPersonBookings: builder.query<PersonBookingResponseType, string>({
			query: () => ({
				url: `${ApiRoutes.Bookings}/for_initiator`,
			}),
			providesTags: ['PersonBookings'],
		}),
	}),
});

export const {
	useGetPersonsQuery,
	useLazyGetPersonByUserIdQuery,

	useGetPersonBookingsQuery,
} = personsApi;
